/**
 * AboutCommunity.tsx — Gold Garage Door / About Us · Section 7/10
 * Navy · "Rooted in Sydney" · service-area grid + Bass Hill home base pin.
 *
 * MOBILE FIX: inline `style` grid overrides Tailwind, so responsive collapse is
 * done with a real <style> media query (class-scoped) — NOT Tailwind classes.
 *
 * 10WEB AI: keep inline SVG + the <style> block. Wave dividers intentional — keep.
 */

const NAVY = "#081438";
const GOLD = "#F5A623";

/** map-pin icon — DO NOT REPLACE WITH IMG */
const Pin = ({
  c = GOLD
}) => <svg data-icon-container="lucide-do-not-replace" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" style={{
  flexShrink: 0
}}><path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" /><circle cx="12" cy="10" r="3" /></svg>;
const REGIONS = [{
  name: "Canterbury-Bankstown",
  href: "/canterbury-bankstown-garage-door-repair/",
  home: true
}, {
  name: "Western Sydney",
  href: "/western-sydney-garage-door-repair/"
}, {
  name: "Eastern Suburbs",
  href: "/eastern-suburbs-garage-door-repair/"
}, {
  name: "Inner West",
  href: "/inner-west-garage-door-repair/"
}, {
  name: "Sutherland Shire",
  href: "/sutherland-shire-garage-door-repair/"
}, {
  name: "North Shore",
  href: "/north-shore-garage-door-repair/"
}, {
  name: "Northern Beaches",
  href: "/northern-beaches-garage-door-repair/"
}, {
  name: "Hills District",
  href: "/hills-district-garage-door-repair/"
}, {
  name: "South Sydney",
  href: "/south-sydney-garage-door-repair/"
}];
export default function AboutCommunity() {
  return <section id="about-community" style={{
    background: `radial-gradient(ellipse at 30% 0%, #14254d 0%, ${NAVY} 55%)`,
    position: "relative",
    overflow: "hidden",
    paddingTop: "5.5rem",
    paddingBottom: "5.5rem"
  }}>
      {/* real media queries — inline style can't be overridden by Tailwind */}
      <style>{`
        .acm-grid { display: grid; grid-template-columns: 0.9fr 1.1fr; gap: 3.5rem; align-items: center; }
        .acm-regions { display: grid; grid-template-columns: repeat(3, 1fr); gap: 0.75rem; }
        @media (max-width: 768px) {
          .acm-grid { grid-template-columns: 1fr; gap: 2rem; }
          .acm-regions { grid-template-columns: repeat(2, 1fr); }
          #about-community { padding-top: 3.5rem; padding-bottom: 3.5rem; }
        }
        @media (max-width: 420px) {
          .acm-regions { grid-template-columns: 1fr; }
        }
      `}</style>

      <div aria-hidden style={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      lineHeight: 0,
      transform: "rotate(180deg)"
    }}>
        <svg viewBox="0 0 1440 48" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        display: "block",
        width: "100%",
        height: "48px"
      }}>
          <path d="M0,48 C360,0 1080,0 1440,48 L1440,48 L0,48 Z" fill="#FAF7F1" />
        </svg>
      </div>

      <svg aria-hidden style={{
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      opacity: 0.05,
      pointerEvents: "none"
    }}>
        <filter id="grain-acm"><feTurbulence type="fractalNoise" baseFrequency="0.65" numOctaves="3" stitchTiles="stitch" /><feColorMatrix type="saturate" values="0" /></filter>
        <rect width="100%" height="100%" filter="url(#grain-acm)" />
      </svg>

      <div aria-hidden style={{
      position: "absolute",
      top: "48px",
      left: 0,
      right: 0,
      height: "1px",
      background: `linear-gradient(90deg, transparent, ${GOLD} 50%, transparent)`
    }} />

      <div className="acm-grid" style={{
      maxWidth: "1150px",
      margin: "0 auto",
      padding: "0 1.5rem",
      position: "relative",
      zIndex: 1
    }}>
        {/* LEFT — copy + home base */}
        <div>
          <span style={{
          fontFamily: "'Manrope', sans-serif",
          fontSize: "0.72rem",
          fontWeight: 700,
          letterSpacing: "0.16em",
          color: GOLD,
          textTransform: "uppercase"
        }}>Rooted In Sydney</span>
          <h2 style={{
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          fontWeight: 800,
          fontSize: "clamp(1.65rem, 6vw, 2.6rem)",
          color: "#FFFFFF",
          lineHeight: 1.15,
          margin: "0.75rem 0 1rem"
        }}>
            A local crew, not a national brand
          </h2>
          <p style={{
          fontFamily: "'Manrope', sans-serif",
          fontSize: "1.02rem",
          color: "rgba(255,255,255,0.72)",
          lineHeight: 1.75,
          marginBottom: "1.75rem"
        }}>
            We're based in Bass Hill and we've never outgrown our backyard. Being
            local means shorter drive times, faster callouts, and a team that
            actually knows Sydney's streets, weather and door styles.
          </p>

          {/* home base card */}
          <div style={{
          background: `linear-gradient(160deg, ${GOLD}14, rgba(255,255,255,0.03))`,
          border: `1px solid ${GOLD}40`,
          borderRadius: "14px",
          padding: "1.5rem",
          display: "flex",
          gap: "1rem",
          alignItems: "center"
        }}>
            <div style={{
            width: "48px",
            height: "48px",
            borderRadius: "12px",
            background: `${GOLD}1A`,
            border: `1px solid ${GOLD}33`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0
          }}>
              <Pin />
            </div>
            <div>
              <div style={{
              fontFamily: "'Manrope', sans-serif",
              fontSize: "0.7rem",
              fontWeight: 700,
              letterSpacing: "0.1em",
              color: GOLD,
              textTransform: "uppercase"
            }}>Home Base</div>
              <div style={{
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: 800,
              fontSize: "1.15rem",
              color: "#fff",
              marginTop: "0.15rem"
            }}>Bass Hill, NSW</div>
              <div style={{
              fontFamily: "'Manrope', sans-serif",
              fontSize: "0.85rem",
              color: "rgba(255,255,255,0.6)",
              marginTop: "0.15rem"
            }}>Fastest response across Canterbury-Bankstown.</div>
            </div>
          </div>
        </div>

        {/* RIGHT — region grid */}
        <div>
          <div className="acm-regions">
            {REGIONS.map((r, i) => <a key={i} href={r.href} style={{
            textDecoration: "none",
            display: "block",
            height: "100%"
          }}>
                <div style={{
              background: r.home ? `${GOLD}14` : "rgba(255,255,255,0.04)",
              border: `1px solid ${r.home ? `${GOLD}50` : "rgba(255,255,255,0.1)"}`,
              borderRadius: "12px",
              padding: "1rem",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              gap: "0.5rem"
            }}>
                  <Pin c={r.home ? GOLD : "rgba(255,255,255,0.5)"} />
                  <div style={{
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontWeight: 700,
                fontSize: "0.88rem",
                color: r.home ? GOLD : "#fff",
                lineHeight: 1.25
              }}>{r.name}</div>
                  {r.home && <div style={{
                fontFamily: "'Manrope', sans-serif",
                fontSize: "0.68rem",
                color: "rgba(255,255,255,0.55)",
                fontWeight: 600
              }}>★ Home turf</div>}
                </div>
              </a>)}
          </div>

          <a href="/service-areas/" style={{
          textDecoration: "none",
          display: "block"
        }}>
            <div style={{
            marginTop: "1rem",
            textAlign: "center",
            padding: "0.9rem",
            border: "1px dashed rgba(255,255,255,0.25)",
            borderRadius: "12px",
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            fontWeight: 700,
            fontSize: "0.9rem",
            color: GOLD
          }}>
              See all 217+ suburbs we cover →
            </div>
          </a>
        </div>
      </div>

      <div aria-hidden style={{
      position: "absolute",
      bottom: "48px",
      left: 0,
      right: 0,
      height: "1px",
      background: `linear-gradient(90deg, transparent, ${GOLD} 50%, transparent)`
    }} />
      <div aria-hidden style={{
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      lineHeight: 0
    }}>
        <svg viewBox="0 0 1440 48" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        display: "block",
        width: "100%",
        height: "48px"
      }}>
          <path d="M0,48 C360,0 1080,0 1440,48 L1440,48 L0,48 Z" fill="#FAF7F1" />
        </svg>
      </div>
    </section>;
}